import React from 'react';
import Footer from '../components/containers/Footer';
import Header from '../components/containers/Header';
import Carousel from '../components/containers/home/Carousel';
import MainProjects from '../components/containers/home/MainProjects';
import Partners from '../components/containers/home/Partners';
import Statistics from '../components/containers/home/Statistics';
import { Helmet } from 'react-helmet';
import Moreonus from '../components/containers/home/Moreonus';

const Home = (props) => {
  return (
    <div>
      <Helmet>
        <title>CARITAS BYUMBA</title>
      </Helmet>
      <Header />
      <Carousel />
      <Moreonus />
      <MainProjects />
      <Partners />
      <Statistics />
      <Footer />
    </div>
  );
};

export default Home;
